define('hierarchicalmenuwidget',["instantsearch", "jquery", "algoliasearch", "algoliasearchhelper", "text!LNRS/Components/Templates/HierarchicalMenuItemTemplate.html"],
    function (instantsearch, $, algoliasearch, algoliasearchhelper, itemTemplate) {

        return function hierarchicalMenuWidget(algoliaApplicationId, algoliaApiKey, algoliaIndexName,
            contextLanguage, search, industryHierarchyDepth, allIndustriesLabel, industryContainer, hierarchicalIndustryRoot, hierarchicalIndustryLevelOneName,

            hierarchicalIndustryLevelTwoName, hierarchicalIndustryAttribute, industriesWithSubIndustries, allProducts, allPressReleases) {

            var widget = instantsearch.widgets.hierarchicalMenu({
                container: industryContainer,
                attributes: hierarchicalIndustryAttribute,
                sortBy: ['name:asc', 'count:desc'],
                autoHideContainer: false,
                templates: {
                    header: allIndustriesLabel,
                    item: itemTemplate
                },
                limit: 1000,
                transformData: {
                    item: function (hit) {

                        if (allProducts) {
                            handleProductPageHits(hit);
                        }

                        if (industriesWithSubIndustries) {
                            var hitPath = hit["path"];
                            var elementsOfPath = hitPath.split(">");
                            var nameOfElement = elementsOfPath[0].trim();

                            if (!nameOfElement.includes(hit.name)) {//if name of item is not on first place of path then this is subindustry
                                return hit;
                            }

                            var haveSubindustry = false;
                            var industry;

                            $.each(industriesWithSubIndustries, function (key, value) {
                                if (hit.name === value.Industry) {
                                    haveSubindustry = true;
                                    industry = value;
                                    return false;
                                }
                            });

                            var currentResource = search.helper.state.hierarchicalFacetsRefinements['_resource_type'];
                            if (haveSubindustry && typeof currentResource != 'undefined') {
                                if (industry.ResourcesAndSolutions.indexOf(String(currentResource).trim()) === -1) {
                                    haveSubindustry = false;
                                }
                            }

                            var currentSolution = search.helper.state.hierarchicalFacetsRefinements['solutions'];
                            if (haveSubindustry && typeof currentSolution != 'undefined') {
                                if (industry.ResourcesAndSolutions.indexOf(String(currentSolution).trim()) === -1) {
                                    haveSubindustry = false;
                                }
                            }

                            if (haveSubindustry) {
                                hit["hasSubItems"] = true;
                            }
                        }

                        if (allPressReleases) {
                            handlePressReleasePageHits(hit);
                        }

                        if (hit["isRefined"]) {
                            hit["collapsedState"] = "expanded";
                        }
                        else {
                            hit["collapsedState"] = "collapsed";
                        }

                        return hit;
                    }
                },
                collapsible: {
                    collapsible: true,
                    collapsed: true
                }
            });

            function triggerIndustryDropdownHeaderClick() {
                // Programmatically click the industry dropdown header without triggering the event handler
                $(industryContainer).find('.ais-hierarchical-menu--header').each(function () {
                    $(this).trigger({
                        type: 'click',
                        isProgrammatic: true // Custom flag to indicate it's programmatic
                    });
                });
            }

            function triggerMinusSignClick() {
                $(industryContainer).find('.ais-hierarchical-menu--collapsable.item-expanded').each(function () {
                    $(this).trigger({
                        type: 'click',
                        isProgrammatic: true // Custom flag to indicate it's programmatic
                    });
                });
            }

            function triggerIndustrySelectedClick(industryText) {
                // Find the industry item based on the industryText
                var industrySelected = $(".ais-hierarchical-menu--list__lvl0")
                    .find("a.ais-hierarchical-menu--link")
                    .filter(function () {
                        return this.innerText.trim() === industryText;
                    }).closest('.ais-hierarchical-menu--item');

                // Trigger a programmatic click on the industrySelected element
                industrySelected.trigger({
                    type: 'click',
                    isProgrammatic: true // Custom flag to indicate it's programmatic
                });
            }


            search.on('render', () => {
                if (waitingForSearch && typeof searchFinishedCallback === 'function') {
                    waitingForSearch = false;
                    searchFinishedCallback();
                }
            });

            let waitingForSearch = false;
            let searchFinishedCallback = null;
            var firstIndustryInteraction = true;

            $(document).on("click", function (e) {
                var target = $(e.target);

                // If the click was triggered programmatically, skip the event handler
                if (e.isProgrammatic) {
                    return;
                }

                if (target.is("#_trackAnalytics")) { return; }

                var hasSubItems = target.closest('.ais-hierarchical-menu--item').data('hassubitems');

                // Handle clicking on the header and collapsing/expanding
                if (target.hasClass('ais-hierarchical-menu--header') && target.parent().hasClass('ais-root__collapsed')) {
                    if (target.text() !== allIndustriesLabel) {
                        target.text(allIndustriesLabel);
                        triggerIndustryDropdownHeaderClick();
                    }
                } else if (target.hasClass('ais-hierarchical-menu--header') && !target.parent().hasClass('ais-root__collapsed')
                    && target.text() === allIndustriesLabel) {

                    var facet, facetIndex;
                    $(hierarchicalIndustryAttribute).each(function (index) {
                        if (!facet) {
                            facet = search.helper.state.hierarchicalFacetsRefinements[hierarchicalIndustryAttribute[index]];
                            facetIndex = index;
                        }
                    });

                    if (facet) {
                        search.helper.clearRefinements(hierarchicalIndustryAttribute[facetIndex]);
                        search.helper.search();
                    }
                } else {
                    updateHierarchyFacetTitle();
                }

                // Handling clicks outside of the industry container and specific targets
                if (!target.closest(industryContainer).length && !target.hasClass('ais-hierarchical-menu--header')
                    && !(hasSubItems && target.hasClass('ais-hierarchical-menu--collapsable'))
                    && !target.hasClass("ais-hierarchical-menu--item__active")) {

                    // If the root is not collapsed, we collapse it or handle clicks on the active item
                    if (!$(industryContainer).find('.ais-hierarchical-menu').hasClass('ais-root__collapsed')) {
                        // Only collapse if a different item is clicked, not on a child like "Payments Efficiency"
                        if (!target.closest('.ais-hierarchical-menu--item__active').length) {
                            $(industryContainer).find(".ais-hierarchical-menu--item__active").click();
                            $(industryContainer).find('.ais-root').addClass('ais-root__collapsed');
                        }
                    }
                } else if (!target.hasClass("ais-hierarchical-menu--item__active") && !target.hasClass("ais-hierarchical-menu--header")
                    && !target.hasClass("item-expanded")) {

                    // Avoid collapsing the active item if it's a valid click on another item
                    if (!target.closest('.ais-hierarchical-menu--item__active').length) {
                        $(industryContainer).find(".ais-hierarchical-menu--item__active").click();
                    }
                    else {
                        // This block handles the selection of a parent industry item that has subitems.
                        // When triggered, it collapses the expanded industry menu via a programmatic click,
                        // which causes Algolia to perform a search (only on the first collapse).
                        // To ensure that post-search actions (like selecting the industry and updating the header)
                        // happen only after the search completes, we use a one-time flag `firstIndustryInteraction`.
                        // On the first interaction, we wait for the search to finish before executing the callback.
                        // On subsequent interactions, we skip the wait and run the logic immediately.
                        if ($(industryContainer).find(".ais-hierarchical-menu--item__active").length > 1 && target.closest('.ais-hierarchical-menu--item').data('hassubitems')) {
                            // find industry text
                            var industryText = target[0].innerText.trim();

                            triggerMinusSignClick();

                            if (firstIndustryInteraction) {
                                waitingForSearch = true;
                                searchFinishedCallback = () => {
                                    triggerIndustrySelectedClick(industryText);
                                    firstIndustryInteraction = false;
                                };
                            } else {
                                triggerIndustrySelectedClick(industryText);
                                triggerIndustryDropdownHeaderClick();
                            }

                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                }

                // Collapse the dropdown after selecting any item
                if (target.hasClass('ais-hierarchical-menu--link')) {
                    var rootElement = $(industryContainer).find('.ais-root');
                    rootElement.addClass('ais-root__collapsed');
                }
            });

            function onIndustryFilterRender() {
                updateHierarchyFacetTitle();

                // disable the dropdown if no options
                var headerContainer = $(industryContainer).find(".ais-header");
                var dropdownContainer = $(headerContainer).closest('div[data-id]');
                var shouldDisable = dropdownContainer.find('.ais-hierarchical-menu--list').children().length === 0;
                dropdownContainer.toggleClass('masonry-resource-listing-filter-disabled', shouldDisable);
            }

            function updateHierarchyFacetTitle() {
                var facet;

                $(hierarchicalIndustryAttribute).each(function (index) {
                    if (!facet) {
                        facet = search.helper.state.hierarchicalFacetsRefinements[hierarchicalIndustryAttribute[index]];
                    };
                });

                var selectedValue = allIndustriesLabel;

                if (facet && facet[0]) {
                    // take only last industry name in whole breadcrumb
                    var lastNameIndex = facet[0].lastIndexOf(' > ');
                    lastNameIndex = lastNameIndex > 0 ? lastNameIndex + 3 : 0;
                    selectedValue = facet[0].substr(lastNameIndex);
                }

                var headerContainer = $(industryContainer).find(".ais-header");
                headerContainer.text(selectedValue);
            }

            function handleProductPageHits(hit) {
                const hasMatchingProduct = allProducts.some(product => {
                    const industryHierarchy = product["IndustryHierarchy"];

                    if (!industryHierarchy) {
                        return false;
                    }

                    const industryList = industryHierarchy["Industry"] || [];
                    const subIndustryList = industryHierarchy["SubIndustry"] || [];

                    const industryMatches = industryList.includes(hit["path"]);

                    const subIndustryMatches = subIndustryList.some(subIndustry =>
                        subIndustry && subIndustry.startsWith(hit["path"] + " >")
                    );

                    return industryMatches && subIndustryMatches;
                });

                hit["hasSubItems"] = hasMatchingProduct ? true : false;
            }

            function handlePressReleasePageHits(hit) {
                var currentSolution =
                    search.helper.state.hierarchicalFacetsRefinements["solutions"] &&
                        search.helper.state.hierarchicalFacetsRefinements["solutions"].length > 0
                        ? search.helper.state.hierarchicalFacetsRefinements["solutions"][0]
                        : '';

                var currentPublicationYear =
                    search.helper.state.hierarchicalFacetsRefinements["publication year"] &&
                        search.helper.state.hierarchicalFacetsRefinements["publication year"].length > 0
                        ? search.helper.state.hierarchicalFacetsRefinements["publication year"][0]
                        : '';

                

                const hasMatchingPressRelease = allPressReleases.some(pressRelease => {
                    const industryHierarchy = pressRelease["IndustryHierarchy"];

                    if (!industryHierarchy) {
                        return false;
                    }

                    const industryList = industryHierarchy["Industry"] || [];
                    const subIndustryList = industryHierarchy["SubIndustry"] || [];

                    const industryMatches = industryList.includes(hit["path"]);

                    const subIndustryMatches = subIndustryList.some(subIndustry =>
                        subIndustry && subIndustry.startsWith(hit["path"] + " >")
                    );

                    // Check if the press release's solution matches the current solution, only if currentSolution is defined
                    const solutionMatches = currentSolution === "All Solutions" || currentSolution === ''
                        ? true
                        : pressRelease["Solutions"].includes(currentSolution);

                    // Check if the press release's publication year matches the current publication year, only if currentPublicationYear is defined
                    const publicationYearMatches = currentPublicationYear === "All Years" || currentPublicationYear === ''
                        ? true
                        : pressRelease["PublicationYear"] === currentPublicationYear;

                    return industryMatches && subIndustryMatches && solutionMatches && publicationYearMatches;
                });

                hit["hasSubItems"] = hasMatchingPressRelease ? true : false;
            }


            return {
                widget: widget,
                onRenderCallback: onIndustryFilterRender
            };
        };
    }
);
